import { PaginationRequestType } from '@/entity/common/pagination.types';
import { ResponseDataType } from '@/form/form.types';
import { IStoreReady } from '@/store/lib/storeSupport';
import { Action, getModule, Module, Mutation, MutationAction, VuexModule } from 'vuex-module-decorators';
import { prepareFormData } from '@/store/utils/formDataHelper';
import store from '@/store';
import { IUsersCosmetologist, IUsersCosmetologistItem, UserCosmetologistAddRequestType } from '@/entity/Settings/UserCosmetologist.types';

@Module({
    namespaced: true,
    name: 'settingsUserCosmetologist',
    store,
    dynamic: true,
})
class UserCosmetologistModule extends VuexModule implements IStoreReady {
    userCosmetologists: IUsersCosmetologist | null = null;
    userCosmetologistItem: IUsersCosmetologistItem | null = null;
    Loaded = false;
    ready = false;

    @MutationAction
    async fetchAll(data?: PaginationRequestType): Promise<{ userCosmetologists: IUsersCosmetologist; Loaded: boolean }> {
        const userCosmetologists = await store.$repository.userCosmetologist.fetchAll(prepareFormData(data));
        let Loaded = false;
        if (userCosmetologists) {
            Loaded = true;
        }
        return { userCosmetologists, Loaded };
    }
    @MutationAction
    async fetchData(data: PaginationRequestType): Promise<{ userCosmetologistItem: IUsersCosmetologistItem; Loaded: boolean }> {
        let Loaded = false;
        const userCosmetologistItem = await store.$repository.userCosmetologist.fetchData(data);
        if (userCosmetologistItem) {
            Loaded = true;
        }
        return { userCosmetologistItem, Loaded };
    }
    @Action({ rawError: true })
    async create(data: UserCosmetologistAddRequestType): Promise<ResponseDataType> {
        const response = await store.$repository.userCosmetologist.create(data);
        console.log('user create response');
        return response;
    }

    @Mutation
    setReady(st: boolean) {
        this.ready = st;
    }
}
export const SettingsUsersCosmetologistStore = getModule(UserCosmetologistModule);
